/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import {
    Component,
    EventEmitter,
    Output,
} from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';

import * as l10n from './log-list-expanded-content.l10n';
import './log-list-expanded-content.component.less';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 *     A wrapper component used for showing the expanded content for log list items.
 *     This component provide a View Full Log button with a handler, while the main content is passed by ng-content.
 * @author Zhiqian Liu
 */
@Component({
    selector: 'log-list-expanded-content',
    templateUrl: 'log-list-expanded-content.component.html',
})
export class LogListExpandedContentComponent {
    /**
     * Handler for opening a c-view to inspect the full log.
     */
    @Output()
    public readonly viewFullLog = new EventEmitter<void>();

    public readonly l10nKeys = l10nKeys;

    constructor(l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }

    public handleViewFullLog(): void {
        this.viewFullLog.emit();
    }
}
